export const actionNames = {
  INIT_AUDIENCE_ROOM: 'WEBINAR_AUDIENCE_ROOM:INIT_AUDIENCE_ROOM',
  LEAVE_AUDIENCE_ROOM: 'WEBINAR_AUDIENCE_ROOM:LEAVE_AUDIENCE_ROOM',
  LIVE_EVENT_NOT_FOUND: 'WEBINAR_AUDIENCE_ROOM:LIVE_EVENT_NOT_FOUND',
  FETCH_LIVE_DATA_SUCCESS: 'WEBINAR_AUDIENCE_ROOM:FETCH_LIVE_DATA_SUCCESS',
  LIVE_STATUS_POLL_SUCCESS: 'WEBINAR_AUDIENCE_ROOM:LIVE_STATUS_POLL_SUCCESS',
  LOCAL_PARTICIPANT_NAME_UPDATED:
    'WEBINAR_AUDIENCE_ROOM:LOCAL_PARTICIPANT_NAME_UPDATED',
  LIVE_COUNTDOWN_ZERO: 'WEBINAR_AUDIENCE_ROOM:LIVE_COUNTDOWN_ZERO',
  WEBINAR_ENDED: 'WEBINAR_AUDIENCE_ROOM:WEBINAR_ENDED',
}

export const initAudienceRoom = (
  liveId,
  liveToken,
  isMobileDevice,
  showThankYou
) => {
  return {
    type: actionNames.INIT_AUDIENCE_ROOM,
    liveId,
    liveToken,
    isMobileDevice,
    showThankYou,
  }
}

export const onLocalParticipantNameUpdated = (name) => {
  return {
    type: actionNames.LOCAL_PARTICIPANT_NAME_UPDATED,
    name,
  }
}

export const onLiveCountdownZero = (name) => {
  return {
    type: actionNames.LIVE_COUNTDOWN_ZERO,
    name,
  }
}
